import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { LIST_TABLE_SX } from '../../mathReports/mathTableStyles';
import { KIND_LABELS, formatMoment, overridePharmacyLabel, overrideValue } from './revenueEntryCalc';
import type { EntryKind, EntryOverride } from './revenueEntryApi';

interface OverrideRowProps {
  item: EntryOverride;
  withActions: boolean;
  canRemove: boolean;
  onRemove: (item: EntryOverride) => void;
}

const OverrideRow = memo(({ item, withActions, canRemove, onRemove }: OverrideRowProps) => (
  <tr>
    <td className="strong nowrap">{overridePharmacyLabel(item)}</td>
    <td className="muted nowrap">{KIND_LABELS[item.kind]}</td>
    <td>{overrideValue(item)}</td>
    <td className="muted nowrap">до {formatMoment(item.until)}</td>
    {withActions && (
      <td className="right nowrap">
        {canRemove && (
          <Tooltip title="Отменить исключение" enterDelay={800} arrow>
            <button type="button" className="act icon danger" aria-label="Отменить исключение" onClick={() => onRemove(item)}>
              <DeleteOutlineIcon />
            </button>
          </Tooltip>
        )}
      </td>
    )}
  </tr>
));

interface EntryOverridesTableProps {
  items: EntryOverride[];
  /** Право отменять исключение по виду правила (продление и разблокировка - одно право, дата - другое) */
  canRemove: Record<EntryKind, boolean>;
  onRemove: (item: EntryOverride) => void;
}

const EntryOverridesTable: React.FC<EntryOverridesTableProps> = ({ items, canRemove, onRemove }) => {
  const withActions = canRemove.extend || canRemove.unlock || canRemove.date;
  return (
    <Box sx={LIST_TABLE_SX}>
      <table>
        <thead>
          <tr>
            <th>Аптека</th>
            <th>Параметр</th>
            <th>Значение</th>
            <th>Срок</th>
            {withActions && <th className="right narrow">Действия</th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <OverrideRow
              key={item.id}
              item={item}
              withActions={withActions}
              canRemove={canRemove[item.kind]}
              onRemove={onRemove}
            />
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default memo(EntryOverridesTable);
